import c from "./index479.js";
import { resolveComponent as o, createElementBlock as r, openBlock as i, createVNode as t, withCtx as s, createTextVNode as a, toDisplayString as p } from "vue";
import m from "./index231.js";
const f = {
  ref: "formRef",
  class: "flex flex-col gap-16 shadow screen-m:flex-row"
};
function d(e, _, h, u, g, w) {
  const n = o("cs-location-autocomplete"), l = o("cs-primary-button");
  return i(), r("div", f, [
    t(n, {
      class: "flex-grow",
      locationLevels: e.locationLevels,
      label: "Ort oder Postleitzahl eingeben",
      onSelect: e.onSelect,
      onHighlighted: e.onHighlighted
    }, null, 8, ["locationLevels", "onSelect", "onHighlighted"]),
    t(l, {
      class: "min-w-fit whitespace-nowrap",
      isCentered: "",
      onClick: e.redirect
    }, {
      default: s(() => [
        a(p(e.buttonText), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 512);
}
const C = /* @__PURE__ */ m(c, [["render", d]]);
export {
  C as default
};
